module.exports = __webpack_public_path__ + "media/Momentum_KnokDoorbell_InstallationVideo_Step12.40f10534.mp4";